import {EmployeeData} from "../../api/performanceAPI";
import {BookingDecision, BookingStatus, CustomerOrStrypes} from "./HeaderFiltersComponent";
import {Button, Td, Tr} from "@chakra-ui/react";
import React, {useEffect} from "react";
import moment from "moment";

interface TableRowProps {
  row: EmployeeData;
  decision: BookingDecision | undefined;
  onDecisionChange: (id: string, decision: BookingDecision) => void;
}
const TableRow: React.FC<TableRowProps> = ({ row, decision, onDecisionChange }) => {

    const markApproval = (status: BookingStatus) => {

        onDecisionChange(row.BookingID, {requested: decision?.requested, status: status})
    }
    const markRequested = (customerOrStrypesmark: CustomerOrStrypes) => {

        onDecisionChange(row.BookingID, {requested: customerOrStrypesmark, status: decision?.status})
    }
    function getColorScheme(button="approve") {
  if (!decision || decision.status === undefined) {
    if ( row.approved)return button==="approve"? "green": "gray";
    if (row.approved !== null && Number(row.approved)=== 0)return button==="approve"? "gray": "red";
      return "gray";
  }
  if (button === "approve")return decision.status === "approve" ? "green" : "gray";
  if (button === "reject")return decision.status === "approve" ? "gray" : "red";
  return
}
function getColorSchemeRequested(button="customer") {
  if (!decision || decision.requested === undefined) {
    if ( row.customerOrStrypes === "Customer Requested")return button==="customer"? "orange": "gray";
    if (row.customerOrStrypes !== null && row.customerOrStrypes === "Strypes Requested")return button==="strypes"? "green": "gray";
      return "gray";
  }
  if (button === "customer")return decision.requested === "Customer Requested" ? "orange" : "gray";
  if (button === "strypes")return decision.requested === "Customer Requested" ? "gray" : "green";
  return
}


    return (
    <Tr key={row.BookingID}   bg={
    decision?.status === "approve"
      ? "green.50"
      : decision?.status === "reject"
      ? "red.50"
      : "transparent"
  } _dark={{bg:
    decision?.status === "approve"
      ? "rgba(72, 187, 120, 0.15)"
      : decision?.status === "reject"
      ? "rgba(245, 101, 101, 0.15)"
      : "transparent"
  }}>
                          <Td>{row.FirstName}</Td>

                          <Td>{moment(row.WorkDate).format("DD-MM-YYYY")}</Td>
                          <Td>{row.AddedValue}</Td>
                          <Td>{row.IncentivePercentage*100}%</Td>
                               <Td>
                                   <div className="d-flex flex-column">
  <Button
    onClick={() => markRequested("Customer Requested")}
    colorScheme={getColorSchemeRequested("customer")}
  >
    Customer Requested
  </Button>
  <Button className={"mt-1"}
    onClick={() => markRequested("Strypes Requested")}
    colorScheme={getColorSchemeRequested("strypes")}
  >
    Strypes Requested
  </Button>
                                       </div>
</Td>
        <Td maxWidth={"400px"} overflow="clip">
            <div className={"d-flex flex-column"}>

                <div>{row.Project}</div>
                <div className={"mt-2"}> {row.Note}</div>
            </div>
        </Td>
        <Td>{row.GM}</Td>
        <Td>{row.DepartmentName}</Td>

                            <Td>
  <Button
    onClick={() => markApproval( "approve")}
    colorScheme={getColorScheme("approve")}
  >
    Approve
  </Button>
  <Button className={"ml-1"}
    onClick={() => markApproval( "reject")}
    colorScheme={getColorScheme("reject")}
  >
    Reject
  </Button>
</Td>
                <Td>{row.approvalLog}</Td>
                                 <Td>{row.BookingID}</Td>
                          <Td>{row.IsInternalEmployee ? "Internal": "External"}</Td>
                        </Tr>
        )
}
export const RowComponent = React.memo(TableRow,
     (prevProps, nextProps) =>
    prevProps.row.BookingID === nextProps.row.BookingID &&
    prevProps.decision?.requested === nextProps.decision?.requested &&
     prevProps.decision?.status === nextProps.decision?.status &&
     prevProps.row.approved === nextProps.row.approved
    &&  prevProps.row.customerOrStrypes === nextProps.row.customerOrStrypes
);